import { render } from "./CreareCerere.vue?vue&type=template&id=690d3ce8&scoped=true&ts=true"
import script from "./CreareCerere.vue?vue&type=script&lang=ts"
export * from "./CreareCerere.vue?vue&type=script&lang=ts"

import "./CreareCerere.vue?vue&type=style&index=0&id=690d3ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-690d3ce8"]])

export default __exports__